import { render, staticRenderFns } from "./CdkSharing.vue?vue&type=template&id=7f8b8792&scoped=true&"
import script from "./CdkSharing.vue?vue&type=script&lang=ts&"
export * from "./CdkSharing.vue?vue&type=script&lang=ts&"
import style0 from "./CdkSharing.vue?vue&type=style&index=0&id=7f8b8792&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b8792",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAction } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListTile,VListTileAction,VListTileTitle,VMenu})
